module.exports = __webpack_public_path__ + "img/pinpaiquanan.75ceadb2.png";